
























import Vue, {VueConstructor} from 'vue'
import {ActiveField} from './BZCore/ActiveField'
import StringField from './Fields/StringField.vue'
import SelectField from './Fields/SelectField.vue'
import ModelSelectField from './Fields/ModelSelectField.vue'
import DynamicListField from './Fields/DynamicListField.vue'
import DateInputField from './Fields/DateInputField.vue'
import PhoneField from './Fields/PhoneField.vue'
import DateTimeRangeField from './Fields/DateTimeRangeField.vue'
import TextareaField from './Fields/TextareaField.vue'
import CheckboxField from './Fields/CheckboxField.vue'
import NumberField from './Fields/NumberField.vue'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    fieldComponent: { reset: () => void },
  }
}>).extend({
  name: 'ActiveField',
  components: {
    DateTimeRangeField,
    DynamicListField,
    SelectField,
    StringField,
    PhoneField,
    ModelSelectField,
    DateInputField,
    TextareaField,
    CheckboxField,
    NumberField
  },
  props: {
    name: {type: String},
    error: {},
    field: {type: Object as () => ActiveField},
    readOnly: {type: Boolean, default: false},
    hidden: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    defaultValue: {},
    value: {},
    scope: {
      default: () => {
        return {}
      }
    },
    formScope: {
      default: () => {
        return {}
      }
    },
    rootScope: {
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      calcedInitialValue: null
    }
  },
  mounted () {
    this.calcInitial()
  },
  methods: {
    reset (): void {
      this.$refs.fieldComponent.reset && this.$refs.fieldComponent.reset()
    },
    onInput (event: any): void {
      this.$emit('input', event)
      this.field.validate(event)
    },
    onError (event: any): void {
      this.$emit('error', event)
    },
    async calcInitial (): Promise<void> {
      if (this.field.initialValue) {
        this.calcedInitialValue = await this.field.initialValue(this.scope, this.rootScope, this.formScope)
      }
    }
  },
  watch: {
    scope: {
      handler () {
        this.calcInitial()
      },
      deep: true
    },
    rootScope: {
      handler () {
        this.calcInitial()
      },
      deep: true
    },
    initialValue: {
      handler () {
        // this.$emit('input', this.initialValue)
      },
      deep: true
    },
  },
  computed: {
    fieldValue: {
      get (): any {
        return this.value
      },
      set (): any {
      }
    } as any,
    initialValue (): any {
      return this.defaultValue || this.calcedInitialValue
    },
    fieldOptions (): any {
      return this.options.options || {}
    },
    options (): any {
      return (this.field && this.field.options) || {}
    },
    fieldLabel (): string {
      return this.field && this.options.label || ''
    },
    fieldName (): string {
      return this.name || this.field.fieldName
    },
    fieldRequired (): boolean {
      return this.required || this.options.required || false
    },
    fieldReadOnly (): boolean {
      return this.readOnly || this.options.readOnly || false
    },
    componentName (): string {
      return this.field.fieldType + '-field'
    },
    fieldPlaceholder (): string {
      return this.options.placeholder || this.options.label || ''
    },
    fieldHidden (): boolean {
      return this.hidden || this.options.hidden || false
    }
  }
})
